import React from 'react';

const SectionContext = React.createContext(null);

export default SectionContext;
